import React from "react";
import { compose, withAppContext } from "containers/HOC";
import { usePortalModal } from "common/effects";
import PaymentModal from "containers/Payments/PaymentModal";

const RenewSubscriptionButton = ({ farm, onPaid, online, refData }) => {
    const { openModal, getModal } = usePortalModal();

    const pay = (farm) => (e) => {
        openModal("PaymentModal", { farms: [farm], onPaid });
    };

    const paymentModal = getModal("PaymentModal", PaymentModal);

    return (
        <>
            {online && (farm.expired || !farm.expirationDate) && refData.deploymentType === "Commercial" && (
                //TODO: when calling http://localhost:5000/farms the farm list returned does not contain the claims and therefore this button will not show on the dashboard
                //utils.canMakePayment(farm) &&
                <button id={`renew-sub-${farm.id}`} className="Button Button--sm Button--alert u-print-none" onClick={pay(farm)}>
                    <i className="icon icon--before icon-dollar" />
                    <span>Pay for subscription</span>
                </button>
            )}
            {paymentModal}
        </>
    );
};

export default compose(withAppContext)(RenewSubscriptionButton);
